<template> 
    <!-- <div class="c-text-both background-layers"  style="margin-top: -90px;height: 350px;background-color: black;"> 
    </div>   -->
    <img src="@/assets/images/news/News Section website.png" alt=""
    style="    height: auto; width: 100%;margin-top: -90px;aspect-ratio: 371 / 74;">
  <div class="c-text-both" >
    <div class="c-text-both c-flex-wrap c-mb-20 c-wrapper c-text-justify-start"> 
      <div v-for="item in newList" :key="item.name" class="newContent">
          <div class="c-mb-5 c-text-both newImg" style="aspect-ratio: 468 / 294;">
            <img :src="item.url" style="width: 100%;height: 100%;" />
          </div> 
          <div class="c-mb-10 c-text-vBetween" style="height: 145px;" > 
              <div  style="text-align: left;">
                  <h2>{{item.title}}</h2>
              </div>
            <span class="content c-mt-5 " :title="item.content" style="text-align: left;">{{item.content}}</span>
          </div>
          <div class="c-text-between">
            <div>1分钟读完</div>
            <div class="c-text-both" style="cursor: pointer;">
              <a :href="item.contentUrl" target="_blank" rel="noopener noreferrer">了解更多</a> 
              <span style="width: 15px;height: 15px;"  class="c-text-both" >
                <svg version="1.0" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 448 512" aria-hidden="true"><g id="long-arrow-alt-right1_layer"><path d="M313.941 216H12c-6.627 0-12 5.373-12 12v56c0 6.627 5.373 12 12 12h301.941v46.059c0 21.382 25.851 32.09 40.971 16.971l86.059-86.059c9.373-9.373 9.373-24.569 0-33.941l-86.059-86.059c-15.119-15.119-40.971-4.411-40.971 16.971V216z"></path></g></svg>
              </span> 
            </div>
          </div>
      </div>
    </div>
  </div>
    <!-- <div> 
      <button :disabled="currentPage === 1" @click="goToPage(currentPage - 1)" class="buttonContro c-mr-5">Prev</button>
 
      <button class="buttonPage"
        v-for="page in totalPages"
        :key="page"
        :class="{ active: page === currentPage }"
        @click="goToPage(page)"
      >
        {{ page }}
      </button>
 
      <button :disabled="currentPage === totalPages" @click="goToPage(currentPage + 1)"  class="buttonContro c-ml-5">Next
        
      </button>
    </div> -->
  </template>
  
  <script> 
  
  export default {
    metaInfo() {
        return {
          title: this.$route.meta.title, // 从路由获取标题
          meta: [
            { 
              name: 'keywords', 
              content: this.$route.meta.metaTags[0]['content']
            }
          ]
        }
      },
    name: 'App',
    components: {
      // HelloWorld
    },
    data(){
      return { 
        currentPage: 1, // 当前页
        totalPages: 4,  // 总页数 
        newList:[ 
        {
          title:'Franka Robotics x Amazon Science：无需真实接触，机器人也能学会“触觉”',
          url:require('@/assets/images/news/a78383dc-7065-464e-9c07-9f1c332d7a5b.png'),
          contentUrl:'https://mp.weixin.qq.com/s/oBcwuvt6_-sPn5EPdfBXfA',
          content:'HydroShear 是一款基于物理建模的高保真触觉仿真器，通过 Hydroelastic Contact（流体弹性接触）模型，精确模拟物体接触过程中力的产生与变化，并结合路径依赖（Path-dependent）的力跟踪机制，完整记录接触历史。'
        },
        {
          title:'Franka Robotics x 蚂蚁灵波丨以高质量真机数据集，共建跨构型具身智能开放生态”',
          url:require('@/assets/images/news/6400.png'),
          contentUrl:'https://mp.weixin.qq.com/s/a4bSor3jjWNavkQcmNQuHA',
          content:'蚂蚁灵波正式开源新⼀代具身基座模型 LingBot-VLA 2.0。作为今年 1 ⽉开源的 LingBot-VLA 1.0 的 全⾯升级，LingBot-VLA 2.0 在构型泛化、⾃由度⽀持和落地效率等⽅⾯实现了显著提升。'
        },
        {
          title:'Franka System Image v5.10 正式发布！赋能机器人配置、开发者工作流及系统集成！',
          url:require('@/assets/images/news/edc6a8c1-1de7-4e49-9580-95350e4f955d.png'),
          contentUrl:'https://mp.weixin.qq.com/s/9Wy2eHYcukQX1jUvxbDdvg',
          content:'Franka Robotics正式推出System Image v5.10，为机器人配置、开发者工作流以及系统集成带来多项全新能力'
        },
        {
          title:'第一届欧洲具身智能盛会EUROPE EMBODIED 2026圆满落幕，Franka与您共赴机器人技术前沿 ！',
          url:require('@/assets/images/news/640 (1).png'),
          contentUrl:'https://mp.weixin.qq.com/s/9Jf9puI01EjzsEYBu-Dxig',
          content:'首届 EUROPE EMBODIED 2026 圆满收官——这是属于机器人社区的一个精彩纷呈的盛会！在为期五天的活动中，来自欧洲各地的研究人员、学生、创业者和工程师齐聚德国慕尼黑，共同交流思想、动手实践，一起推动机器人技术与物理AI的前沿发展。'
        },
        {
          title:'Franka Robotics × Sashimi-Bot：机器人学会切刺身，柔性操作能力实现新跨越！',
          url:require('@/assets/images/news/5c7bdcd1-60d7-49ae-a59e-493cdaa50625.png'),
          contentUrl:'https://mp.weixin.qq.com/s/Pbet7gZEdozedAr0Bf6HMg',
          content:'近期，多家知名研究机构联合在Nature Portfolio 机器人学期刊《npj Robotics》发布了Sashimi-Bot: autonomous tri-manual advanced manipulation and cutting of deformable objects 自主三机械臂柔性物体操作与切割系统。'
        },
        {
          title:'重磅发布｜Franka LABS 正式开源！助力 Physical AI',
          url:require('@/assets/images/news/640 (2).png'),
          contentUrl:'https://mp.weixin.qq.com/s/g3mhtmukb1gobLShN0UF8w',
          content:'LABS 是 Franka Robotics 推出的机器人数据采集与行为学习平台，旨在帮助研究人员和开发者更高效地完成从示教采集、数据记录到机器人学习数据集生成的全流程工作。'
        },
        {
          title:'Franka Robotics 携FR3 Duo亮相Google Cloud Next 2026！',
          url:require('@/assets/images/news/640 (3).png'),
          contentUrl:'https://mp.weixin.qq.com/s/-8lMhXyvdc-yku31u0oYmA',
          content:'作为 Google DeepMind 在机器人方向的重要合作伙伴之一，Franka Robotics 受邀参与大会 Showcase，带来了面向 Physical AI 的双臂平台 —— FR3 Duo。在 Google Cloud Next 2026 上展示机器人与 Physical AI 的最新突破。'
        },
        {
          title:'Franka Robotics 十周年 |  创新不息，探索未止！',
          url:require('@/assets/images/news/640 (4).png'),
          contentUrl:'https://mp.weixin.qq.com/s/2d9f9ON4oqNOWNE2Terj4Q',
          content:'2016 年汉诺威工博会，Franka Robotics 初次亮相。彼时，我们怀揣一个朴素的愿景：打造开放、标准化的机器人研究与开发平台，降低技术门槛，让研究人员、开发者和企业能够更自由地实验、训练和应用落地。'
        },
        {
          title:'Franka Robotics 重磅亮相 IROS 2025，与全球顶尖学者共话机器人未来！',
          url:require('@/assets/images/news/640(5).png'),
          contentUrl:'https://mp.weixin.qq.com/s/sEzdlgqzK3coP1IgKmqvdw',
          content:'2025年10月19日-25日，Franka Robotics 亮相IEEE/RSJ 智能机器人与系统国际会议。IROS 是全球机器人与智能系统领域的顶级盛会，是机器人领域全球范围内规模最大、水平最高、影响力最广的学术会议之一。'
        },
        {
          title:'CoRL 2025｜Franka Robotics 与Google DeepMind 的联合创新演示，将机器人智能推向新高度！',
          url:require('@/assets/images/news/640 (11).png'),
          contentUrl:'https://mp.weixin.qq.com/s/f-a0pStvP_ULa877d2JQig',
          content:'2025年9月27日-30日，Franka Robotics 于#韩国首尔亮相 #CoRL（Conference on Robot Learning） 由 #机器人 和#机器学习 领域的专家共同发起，聚焦于机器人与机器学习的交叉领域，尤其是 机器人感知、控制、学习和决策中的智能技术'
        }
        , 
        {
          title:'Art in Robotic Arm | 上海纽约大学与 Franka Robotics 跨界合作，共同探索机器人的艺术！',
          url:require('@/assets/images/news/640.png'),
          contentUrl:'https://mp.weixin.qq.com/s/G4_0_evkZLfbmYAgOXsitw',
          content:'2025 年春季学期，上海纽约大学互动媒体艺术（IMA）项目与 Franka Robotics 携手合作，探索艺术、科技与机器人技术交汇处的无限创意。'
        }, 
        {
          title:'全新亮相 | Franka Research 3 实力升级！',
          url:require('@/assets/images/news/6401.png'),
          contentUrl:'https://mp.weixin.qq.com/s/F1iqZtgYk8eecDW_Kh6GUg',
          content:'Franka Research 3（FR3）持续升级。作为一个高性能机器人研究平台，FR3采用了世界领先的高灵敏力控机器人系统，让使用者在容易使用的同时还获得底层控制权限。本次升级显著提升了FR3的灵活性、精度与集成能力，为全球科研人员及机器人专家赋能'
        }, 
        {
          title:'展会前沿｜Franka Robotics双臂平台亮相 Automatica，全新升级Franka Research 3不容错过！',
          url:require('@/assets/images/news/6402.png'),
          contentUrl:'https://mp.weixin.qq.com/s/-RqjgQqS7p3d_hcFe3LdbQ',
          content:'2025年德国慕尼黑国际自动化技术展览会Automatica 正盛大举行, 思灵机器人（Agile Robots) 旗下的Franka Robotics 于展会隆重发布全新升级版 Franka Research 3及四款 Franka Research 3 Duo (FR3 Duo) 双臂机器人系统平台，吸引众多来访者驻足体验并与深度交流！'
        }, 
        {
          title:'系统升级 | Franka Research 3 全新 v5.8 版本正式发布',
          url:require('@/assets/images/news/6403.png'),
          contentUrl:'https://mp.weixin.qq.com/s/X72Je2hsTLF1yZFlDrHEpA',
          content:'Franka Research 3 （以下简称 “FR3”）v5.8 全新系统升级 ！本次系统升级全面更新五大功能模块，优化智能控制功能，提升系统稳定性，为开发者提供更为高效、可靠的机器人研发平台。欢迎立即更新版本，开启高效研发新篇章！'
        }, 
        {
          title:'科技竞赛 | Franka Robotics 助力慕尼黑工大-MIRMI 团队在2025慕尼黑机器人创新竞赛中拔得头筹！',
          url:require('@/assets/images/news/1743473872755.jpg'),
          contentUrl:'https://mp.weixin.qq.com/s/vqjv3stIXAgA3bGqLXomOQ',
          content:'3月17日至3月20日，慕尼黑举办的 robo.innovate Hackathon 机器人创新竞赛圆满落幕。Franka Robotics 与多个机器人团队携手亮相，围绕机器人、人工智能及自动化领域展开深入创新研究，碰撞出激动人心的科技火花。'
        }, 

        {
          title:'思灵机器人Agile Robots的Diana 7现全面适配FCI接口，助力完善 Franka Robotics 生态系统！',
          url:require('@/assets/images/news/640.jpg'),
          contentUrl:'https://mp.weixin.qq.com/s/Zo9WYd0zTSSMABFGmrLtOw',
          content:'近日，思灵机器人 Agile Robots 旗下的 Diana 7 机械臂现已全面支持 Franka Control Interface（FCI），实现了与 FCI 控制接口的适配，从而与Franka Research 3机械臂形成互补，扩充了其负载能力和臂展范围，赋能更多应用场景，进一步完善Franka Robotics的生态系统。'
        }, 
        // {
        //   title:'NVIDIA、AWS和Franka Robotics通力合作，提高机器人仿真及AI模型训练效率！',
        //   url:require('@/assets/images/news/140.jpg'),
        //   contentUrl:'https://mp.weixin.qq.com/s/dm9WfV_5MQv-o7s7jDOv1A',
        //   content:'近日，NVIDIA 宣布：英伟达的机器人仿真平台 Isaac Sim 现可在AWS的虚拟服务器的 NVIDIA L40S GPU 上运行。这使机器人仿真和及AI模型训练进程速度提升了两倍！'
        // }, 
        {
          title:'ROSCon 2024 | Franka Robotics 与ROS共塑机器人未来！',
          url:require('@/assets/images/news/image.png'),
          contentUrl:'https://mp.weixin.qq.com/s/rryEAWMUS4c8YTGjQ0osgQ',
          content:'2024年11月，Franka Robotics在丹麦欧登塞举办的ROSCon 2024上闪亮登场。ROSCon是围绕机器人操作系统（ROS）举办的全球性年度会议，也是开源机器人社区的顶级盛会。ROSCon为开发者、研究者和机器人爱好者提供了一个交流、学习和合作的平台。本次活动吸引了全球顶尖的开发者、研究者以及机器人爱好者齐聚一堂，探讨ROS生态系统中的最新突破和前沿应用！'
        }, 
        // {
        //   title:'CoRL 2024 | 谷歌DeepMind、Meta与Franka Robotics共探机器人学习领域新突破！',
        //   url:require('@/assets/images/news/1741166677850.jpg'),
        //   contentUrl:'https://mp.weixin.qq.com/s/yAuQuQfj79HuJyMboOybpg',
        //   content:'机器人学习会议CoRL (Conference on Robot Learning) 是一年一度的国际会议，会议重点讨论机器人和机器学习的交叉学科。今年于11月6日至9日在德国慕尼黑盛大举行，吸引了众多机器人界专业人士及同行业伙伴参观并聆听学术成果的发表！'
        // }, 
        {
          title:'IROS 2024 | 多篇基于Franka Robotics 机械臂的学术论文在国际智能机器人与系统会议上发表',
          url:require('@/assets/images/news/微信图片_20250306092038.jpg'),
          contentUrl:'https://mp.weixin.qq.com/s/DQmtl4wo1qvwmuom3xuypw',
          content:'IROS (International Conference on Intelligent Robots and Systems) - 国际智能机器人与系统会议是全球规模最大、影响力最强的机器人研究会议之一。作为全球最负盛名的会议之一，IROS于今年10月14日至18日在阿布扎比盛大举行，吸引了来自世界各地近1万名研究人员及参会者。'
        }, 
        {
          title:'Franka Robotics 回归中国 | 首次亮相工博会，带您打开人工智能和机器人研究等创新领域的新篇章！',
          url:require('@/assets/images/news/微信图片_20250306092304.jpg'),
          contentUrl:'https://mp.weixin.qq.com/s/4TxNIyorOVldy7uc4UKorQ',
          content:'第二十四届中国国际工业博览会盛大开幕！这是Franka Robotics在工博会的首次亮相。作为世界领先的人工智能和机器人研究平台，Franka Robotics 凭借卓越的适应性安装、配备英伟达GPU的AI Companion等五项应用展示，吸引了来自科研教育、医疗等专业人士的广泛关注。'
        }, 
        {
          title:'Franka Robotics 助力温室农业自动化!',
          url:require('@/assets/images/news/微信图片_20250306092441.jpg'),
          contentUrl:'https://mp.weixin.qq.com/s/YvwrLyO0A2JKwOFprQdYAw',
          content:'西门子数字工业软件的前沿技术搭配 Franka Robotics机械臂，由德国 Organifarms公司设计的BERRY, 正在改变温室农业, 实现自动化草莓采摘。这是可持续性与自动化在温室农业领域的结合！'
        }, 
        {
          title:'辅助外科医生的机器人助手，推动医学技术迈向新高峰!',
          url:require('@/assets/images/news/141.jpg'),
          contentUrl:'https://mp.weixin.qq.com/s/ctRBj-U6bCx0iilSy55U7Q',
          content:'慕尼黑工业大学伊萨尔河畔医院（TUM Universitätsklinikum Klinikum rechts der Isar）的研究团队成功开发了一项具有革命性意义的项目 —— 一款能够在手术过程中自动递送所需手术器械的机器人助手，并且无需外科医生发出任何口头指令。这一创新成果近日发表在权威期刊《通信医学》（Communications Medicine）上。'
        }, 

        // {
        //   title:'基于手机扫描，模拟训练 Franka Robotics机器人做家务!',
        //   url:require('@/assets/images/news/微信图片_20250306092836.png'),
        //   contentUrl:'https://mp.weixin.qq.com/s/AQWY-sGJ4K_vE1EGsZC3wQ',
        //   content:'麻省理工学院计算机科学与人工智能实验室使用Franka Robotics的机械臂开发出一种模拟训练家用机器人的新方法！人们可以使用iPhone手机扫描自己家的一部分，将其上传到模拟系统中。'
        // }, 
        {
          title:'慕尼黑工业大学借助Franka Robotics的机器人引领触觉创新！',
          url:require('@/assets/images/news/微信图片_20250306093209.png'),
          contentUrl:'https://mp.weixin.qq.com/s/8eHT-6H3p0xiSfn4vql-Lg',
          content:'慕尼黑工业大学TUM (Technical University of Munich) 领导的团队在进行八年的研究工作后，使用Franka Robotics的机器人首次发布，名为“触觉互联网的触觉编解码器”（HCTI）的标准。这一创新标准为远程手术、远程驾驶和新的在线游戏体验奠定了基础，标志着触觉传递技术的重大突破！'
        }, 






        // {
        //   title:'思灵机器人 Agile Robots 助力小米汽车，打造了汽车电子“域控制器”柔性组装线！',
        //   url:require('@/assets/images/news/642.jpg'),
        //   contentUrl:'https://mp.weixin.qq.com/s/-YdUSbF7zO7lRtHCbLkN5Q',
        //   content:'随着新能源汽车产业的快速发展，机器人技术与柔性智能化产线已成为推动产业升级的核心动力。思灵机器人2024年交付了小米汽车电子的域控制器组装线。该产线凭借柔性化设计、高度自动化与智能化的核心优势，构建出兼容性强的柔性生产模式，能够高效适应多样化的产品需求及未来技术升级，不仅显著提升生产效率，还有效降低了运营成本。'
        // }, 
        // {
        //   title:'客户案例｜思灵机器人（Agile Robots）与宝马（BMW）携手推出创新解决方案-移动式自动收货机器人！',
        //   url:require('@/assets/images/news/643.jpg'),
        //   contentUrl:'https://mp.weixin.qq.com/s/aGkEspbKeyzt0i6GyDYLXw',
        //   content:'近日，思灵机器人（Agile Robots）与宝马（BMW）在物流生产领域取得了突破性进展，针对以往人工扫码喷码时遇到的：码垛高度较高人工扫码难度大、人工填写仓储信息易错、劳动强度大等痛点，思灵机器人联合宝马开发了移动式自动收货机器人，用于进口件来料接收。该创新解决方案实现了全厂物流环节收货理货的智能化、数字化和信息化。'
        // }, 
        // {
        //   title:'客户案例 ｜思灵机器人（Agile Robots）推出智能力控机器人拍摄系统，助力摄影创新与效率提升！',
        //   url:require('@/assets/images/news/644.jpg'),
        //   contentUrl:'https://mp.weixin.qq.com/s/DxY2vo0JVHkNpqf1dK_0tw',
        //   content:'随着摄影行业的快速发展以及技术的不断创新，拍摄方式也迎来了快速的更新迭代，机器人摄影作为创新手段之一为摄影师提供了更加新颖的拍摄方式。然而，传统工业机器人由于编程门槛高、运行过程中存在较高的安全风险等问题，限制了其在摄影领域的广泛应用。针对这些问题，思灵机器人Agile Robots经过深入研发，成功推出了这款具有多项创新特点的智能力控机器人拍摄系统。'
        // }, 
        // {
        //   title:'产品技术升级丨Zeus4无人值守电力巡检操作机器人解决方案',
        //   url:require('@/assets/images/news/645.jpg'),
        //   contentUrl:'https://mp.weixin.qq.com/s/S-mN_t_9Y0d8yDwMA-ngpw',
        //   content:'随着智能电网的快速发展，面对传统配电间面临着运维效率低、安全隐患多、开关柜与机器人适配度低、数据孤岛化等挑战，思灵机器人携手业界知名的开关柜制造商与微机五防技术的领航者，汇聚三方之精华，以卓越的实力与前瞻的洞察力为基础，通过深度的战略合作与技术创新的火花碰撞，精准锁定并攻克中、高压配电间面临的复杂难题，为客户精心打造了一套智慧高压配电间的全方位、一体化无人值守解决方案。'
        // },
        // {
        //   title:'案例丨思灵机器人（Agile Robots）推出全自动复合机器人解决方案',
        //   url:require('@/assets/images/news/1741069475495.png'),
        //   contentUrl:'https://mp.weixin.qq.com/s/OwctKiTPo8pXvolargLyjw',
        //   content:'在3C消费电子等多行业中，全自动复合机器人已经成为提升生产效率、保障产品质量和推动自动化转型的重要工具。作为一种集成移动机器人和工业机器人两项功能为一身的新型机器人，全自动复合机器人具有“手、脚、眼、脑”的综合能力。全自动复合机器人融合了AGV/AMR的移动性和机械臂的操作性，实现了更高的柔性化、快速反馈和易操作性，成为实现工业生产智能化的关键设备。'
        // },
        // {
        //   title:'思灵机器人Agile Robots亮相第二十四届工博会，以卓越的创新技术和新型解决方案吸引了广泛关注！',
        //   url:require('@/assets/images/news/647.jpg'),
        //   contentUrl:'https://mp.weixin.qq.com/s/St3Tx3zvJ-GZQqH4E7B_8g',
        //   content:'本次工博会中，思灵机器人（8.1H F006）在多个专区展示其最新型的解决方案，涵盖了3C行业、电力行业、半导体行业、焊接行业、汽车行业、理疗行业及智能机器人领域。这些解决方案不仅展示了思灵机器人在技术上的领先地位，更体现了其对行业需求的深刻理解和精准把握！'
        // },
        // {
        //   title:'思灵机器人（Agile Robots）携手工业富联助力深圳技能大赛完美收官！',
        //   url:require('@/assets/images/news/645.jpg'),
        //   contentUrl:'https://mp.weixin.qq.com/s/WanOWcVlsAdP3nHBSwTsFA',
        //   content:'8月25日.由深圳市人力资源和社会保障局.深圳市总工会主办,深圳市龙华区人力资源局,富士康科技集团工会联合会,思灵(深圳)智能机器人科技有限责任公司承办,富士康工业互联网股份有限公司工会委员会协办的深圳市第十四届职工技术创新运动会,暨2024年深圳技能大赛--工业机器人系统操作员职业技能竟赛决赛,在龙华区大浪街道德泰科技园顺利举办'
        // },
        // {
        //   title:'Diana和Thor系列家族再添新员！思灵重磅推出五款新品',
        //   url:require('@/assets/images/news/648.jpg'),
        //   contentUrl:'https://mp.weixin.qq.com/s/Nt1oE3zxUbBh0GNf-mw8UQ',
        //   content:'近日，思灵机器人（Agile Robots）进一步扩大Diana系列和Thor系列家族，推出五款智能机器人，覆盖更广泛的领域，为客户提供更多选择和更高性能。智能机器人包括Diana家族的Diana3、Thor家族的Thor3、Thor7、Thor7Pro、Thor12，适用于从3kg到12kg的负载范围，工作半径从600mm到1300mm，能为用户提供更多样化的选择，满足不同任务场景下的需求，帮助用户实现自动化操作和提高工作效率。'
        // },
        // {
        //   title:'操作简便：Franka机器人赋能利勃海尔的实习生',
        //   url:require('@/assets/images/news/Screenshot 2024-07-12 103408.jpg'),
        //   content:'Liebherr 对创新和效率的承诺的核心在于其无缝整合的'
        // }, 
        // {
        //   title:'Franka MATLAB Toolbox 介绍：加强机器人研究',
        //   url:require('@/assets/images/news/_Franka Robotics _Franka AI Companion_20241781.jpg'),
        //   content:''
        // }, 
        // {
        //   title:'Franka Robotics 推出 Franka AI 伴侣：赋能机器人研究中的创新',
        //   url:require('@/assets/images/news/_Franka Robotics _Franka AI Companion_20241781.jpg'),
        //   content:''
        // }, 
        // {
        //   title:'Franka MATLAB Toolbox 介绍：加强机器人研究',
        //   url:require('@/assets/images/news/Picture_Franka Matlab Toolbox One Pager.jpg'),
        //   content:''
        // }, 
        // {
        //   title:'介绍 Franka MATLAB 工具箱：赋能机器人研究',
        //   url:require('@/assets/images/news/Picture_Franka Matlab Toolbox One Pager.jpg'),
        //   content:''
        // }, 
        // {
        //   title:'介绍 Franka MATLAB 工具箱：赋能机器人研究',
        //   url:require('@/assets/images/news/Agile Robots ramps up production of Franka robots in Kaufbeuren.jpg'),
        //   content:''
        // }, 
        ]
        
      }
    }, 
    methods: {
    // 跳转到指定页码
    goToPage(page) {
      if (page < 1 || page > this.totalPages) return;
      this.currentPage = page;
    }
  }
  }
  </script>
  
  <style scoped>
  .buttonContro{
    background-color: white;
    border: 2px solid #b0c1d400;
    cursor: pointer;
    font-size: 16px;

  }
  .buttonContro:hover{
    color: #0b7bb3;

  }
  .c-wrapper{
    width: 1100px;
  }
  .buttonPage{
    background-color: white; 
    border: 2px solid #b0c1d400;
    cursor: pointer;
    line-height: 1;
    margin: 0 0.1rem;
    padding: 0.25rem 0.4rem;
    text-decoration: none;
    border-radius: 7px;
    font-size: 16px;
  }
  .buttonPage:hover{
    border: 2px solid #b0c1d4;

  }
  button.active {
    font-weight: bold;
    border: 2px solid #b0c1d4;
    border-radius: 7px;
  }
  button:disabled {
    color: #ccc;
  }
  .content {
    display: -webkit-box;
    -webkit-line-clamp: 2; /* 限制为2行 */
    -webkit-box-orient: vertical;
    overflow: hidden; /* 隐藏超出的内容 */
    text-overflow: ellipsis; /* 添加省略号 */
    font-size: 14px; /* 默认字体大小 */
  }
  .newContent{
     width: 500px;
     padding: 16px;
     box-shadow: -5px 0px 20px 0px rgb(73 75 77 / 10%);
     margin: 20px;

  }
  .newImg{
    height: 300px;
  }
  @media (max-width: 1029px) {
    .newContent{
      width: 100%; 

    } 
    
    .c-wrapper{
      width: 100%;
    }
  .newImg{
    height: 100%;
  }
}
   .background-layers{
      background-image: url(../assets/images/news/news2.jpg) !important;
      background-size: 100% 100%;
      /* aspect-ratio: 468 / 294; */
      /* background-position: center bottom !important;
      background-size: cover !important;
      background-repeat: no-repeat !important; */
  } 
  </style> 